export default __webpack_public_path__ + "static/media/ep7.0b7ff35f.jpeg";